import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';

import Button from '../../../inputs/button/Button';
import AddForm from '../../addform/AddForm';
import FormActions from '../../formactions/FormActions';
import FormField from '../../formfield/FormField';
import { ZoneValidations } from '../../../../models';

export class ZoneInfoForm extends Component {
  handleSiteSelect = (_, value) => {
    this.props.onSiteSelect(value.id);
  };
  handleAreaSelect = (_, value) => {
    this.props.onAreaSelect(value);
  };
  render() {
    const sites = this.props.sites
      ? this.props.sites.map(site => ({
          value: site,
          label: site.name
        }))
      : [];

    const areas =
      this.props.site &&
      this.props.site.id &&
      this.props.site.id in this.props.areas &&
      this.props.areas[this.props.site.id].map(item => ({
        value: item,
        label: item.name
      }));

    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('add.zone.zone.label')}
          type="text"
          placeholder={I18n.t('add.zone.zone.placeholder')}
          component={FormField}
          validate={ZoneValidations.zone}
        />
        <Field
          name="site"
          label={I18n.t('add.zone.site.label')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.zone.site.placeholder')}
          options={sites}
          onChange={this.handleSiteSelect}
          validate={ZoneValidations.site}
        />
        <Field
          name="area"
          label={I18n.t('add.zone.area.label')}
          type="select"
          component={FormField}
          placeholder={I18n.t('add.zone.area.placeholder')}
          options={areas}
          onChange={this.handleAreaSelect}
          validate={ZoneValidations.area}
        />
        <FormActions>
          <Button>{I18n.t('add.add')}</Button>
        </FormActions>
      </AddForm>
    );
  }
}


const selector = formValueSelector('addzone');
const mapStateToProps = state => {
  return { site: selector(state, 'site') };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addzone',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(ZoneInfoForm)
);



// WEBPACK FOOTER //
// ./src/components/forms/addzoneform/zoneinfoform/ZoneInfoForm.js